;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = require("../mixins/tabs");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    cats: {
      type: Array,
      default: function _default() {
        return [{ name: "cars", title: "Легковые", icon: { width: 62, height: 24 } }, { name: "cargo", title: "Грузовые", icon: { width: 82, height: 37 } }, { name: "agro", title: "Сельхоз", icon: { width: 55, height: 41 } }, {
          name: "moto",
          title: "Мототехника",
          icon: { width: 56, height: 30 }
        }];
      }
    }
  },
  mixins: [(0, _tabs2.default)("cats")]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-cats"},[_c('div',{staticClass:"ss-cats__header"},[_c('div',{staticClass:"ss-cats__buttons"},_vm._l((_vm.cats),function(cat){return _c('button',{key:cat.name,staticClass:"ss-cats__button",class:{ 'is-active': cat.name === _vm.current },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle(cat.name)}}},[_c('Icon',{attrs:{"name":cat.name,"width":cat.icon.width,"height":cat.icon.height}}),_c('span',{staticClass:"ss-cats__button-label"},[_vm._v(_vm._s(cat.title))])],1)}),0)]),_c('div',{staticClass:"ss-cats__body"},[_c('ul',{staticClass:"ss-cats__list"},_vm._l((_vm.cats),function(cat){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(cat.name === _vm.current),expression:"cat.name === current"}],key:cat.name,staticClass:"ss-cats__item"},[_vm._t(cat.name)],2)}),0)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f31eec9", __vue__options__)
  } else {
    hotAPI.reload("data-v-1f31eec9", __vue__options__)
  }
})()}